import { z } from 'zod';
export var CaptchaType;
(function (CaptchaType) {
    CaptchaType["RecaptchaEnterprise"] = "RecaptchaEnterprise";
    CaptchaType["Turnstile"] = "Turnstile";
    CaptchaType["Aliyun"] = "Aliyun";
})(CaptchaType || (CaptchaType = {}));
export const aliyunCaptchaRegionGuard = z.enum(['cn', 'sgp']);
export const aliyunCaptchaPrefixGuard = z
    .string()
    .regex(/^(?=.{1,63}$)[\da-z](?:[\da-z-]*[\da-z])?$/);
export var RecaptchaEnterpriseMode;
(function (RecaptchaEnterpriseMode) {
    RecaptchaEnterpriseMode["Invisible"] = "invisible";
    RecaptchaEnterpriseMode["Checkbox"] = "checkbox";
})(RecaptchaEnterpriseMode || (RecaptchaEnterpriseMode = {}));
export const turnstileConfigGuard = z.object({
    type: z.literal(CaptchaType.Turnstile),
    siteKey: z.string(),
    secretKey: z.string(),
});
export const recaptchaEnterpriseConfigGuard = z.object({
    type: z.literal(CaptchaType.RecaptchaEnterprise),
    siteKey: z.string(),
    secretKey: z.string(),
    projectId: z.string(),
    domain: z.string().optional(),
    mode: z.nativeEnum(RecaptchaEnterpriseMode).optional(),
});
export const aliyunCaptchaConfigGuard = z.object({
    type: z.literal(CaptchaType.Aliyun),
    region: aliyunCaptchaRegionGuard,
    prefix: aliyunCaptchaPrefixGuard,
    sceneId: z.string().min(1),
});
export const captchaConfigGuard = z.discriminatedUnion('type', [
    turnstileConfigGuard,
    recaptchaEnterpriseConfigGuard,
    aliyunCaptchaConfigGuard,
]);
/**
 * The subset of provider configuration that is safe to expose to the Experience frontend.
 * Provider secrets are intentionally not part of this schema.
 */
export const captchaPublicConfigGuard = z.discriminatedUnion('type', [
    z.object({
        type: z.literal(CaptchaType.Turnstile),
        siteKey: z.string(),
    }),
    z.object({
        type: z.literal(CaptchaType.RecaptchaEnterprise),
        siteKey: z.string(),
        domain: z.string().optional(),
        mode: z.nativeEnum(RecaptchaEnterpriseMode).optional(),
    }),
    z.object({
        type: z.literal(CaptchaType.Aliyun),
        region: aliyunCaptchaRegionGuard,
        prefix: aliyunCaptchaPrefixGuard,
        sceneId: z.string().min(1),
    }),
]);
